import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Button, Card, Grid, Header, Icon, Label, Message, Segment } from 'semantic-ui-react';
import { getButtonSize } from '../../../../app/common/util/util';
import { Permit } from '../../../../app/models/permit';
import { useStore } from '../../../../app/stores/store';
import RiderCardContent from '../../common/RiderCardContent';
import PermitDetailedRiderAddForm from './PermitDetailedRiderAddForm';
import PermitDetailedRiderEditForm from './PermitDetailedRiderEditForm';

export default observer(function PermitDetailedRiderPopupPage() {
    const {modalStore, permitStore} = useStore();
    const {editRiders, removeRider, permit, tempPermit, cancelRiders} = permitStore;
    const {openModal2, closeModal} = modalStore;
    const [addRiderMode, setAddRiderMode] = useState(false);
    const buttonSize= getButtonSize();

    function handleCancelBtn() {
        cancelRiders();
        closeModal();
    }

    function messageBox(values: Permit) {
        const {riders, permitTypeId} = values;
        if (permitTypeId === 2 && riders.length < 2) {
            return (
            <Message icon color='yellow'>
                <Icon name='exclamation' />
                <Message.Content>
                    <Message.Header>Requirement</Message.Header>
                    Please add minimum of 2 riders required not including yourself.
                </Message.Content>
            </Message>
            );
        } else if (permitTypeId === 3 && riders.length < 4){
            return (
            <Message icon color='yellow'>
                <Icon name='exclamation' />
                <Message.Content>
                    <Message.Header>Requirement</Message.Header>
                    Please add minimum of 4 riders required not including yourself.
                </Message.Content>
            </Message>
            )
        }
    }
    
    return (
        <>
            <Segment attached clearing>
                <Grid>
                    <Grid.Column width={16}>
                        <Header 
                            floated='left' 
                            as='h2' 
                            icon='users' 
                            content='Update Rider Information'
                        />
                        <Button 
                            floated='right' 
                            basic 
                            size={buttonSize}
                            content={addRiderMode ? 'Cancel' : 'Add Rider'}
                            onClick={() => setAddRiderMode(!addRiderMode)}
                        />
                    </Grid.Column>
                    <Grid.Column width={16}>
                        {!addRiderMode
                            &&
                            messageBox(permit!)
                        }

                        {addRiderMode ? (
                            <PermitDetailedRiderAddForm
                                setAddRiderMode={(status: boolean) => setAddRiderMode(status)} 
                            />
                        ) : (
                            <Card.Group itemsPerRow={3} stackable doubling>
                            {tempPermit.riders.map((rider, i) => (
                                <Card key={`${i}`}>
                                    <Label 
                                        size='large'
                                        attached='top'
                                        className='!bg-green-800 !text-white'
                                    >
                                    <Icon name='user' />
                                    Rider {i + 1}
                                    </Label>
                                    <RiderCardContent rider={rider} />

                                    <div className='ui two buttons'>
                                        <Button 
                                            basic 
                                            color='green'
                                            value={i}
                                            onClick={() => 
                                                openModal2(<PermitDetailedRiderEditForm
                                                    rider={tempPermit.riders[i]}
                                                />)
                                            }
                                            size={buttonSize}
                                        >
                                            Edit
                                        </Button>
                                        <Button 
                                            basic 
                                            negative
                                            value={i}
                                            // disabled={permit.riders.length <= 2}
                                            onClick={() => removeRider(i)} 
                                            size={buttonSize}
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                </Card>
                            ))}
                            </Card.Group>
                        )}
                    </Grid.Column>

                    {!addRiderMode &&
                    <Grid.Column width={16}>
                        <Button
                            content='Cancel'
                            size={buttonSize}
                            onClick={() => handleCancelBtn()}
                        />
                        <Button
                            disabled={permit!.permitTypeId === 2 ? tempPermit!.riders.length < 2 : tempPermit!.riders.length < 4}
                            floated='right'
                            positive
                            onClick={() => editRiders(permit!.riders)}
                            content='Update'
                            size={buttonSize}
                        />
                    </Grid.Column>}
                </Grid>
            </Segment>
        </>
    )
})